var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSearch,
              expression: "showSearch",
            },
          ],
          ref: "queryForm",
          attrs: {
            model: _vm.queryParams,
            size: "small",
            inline: true,
            "label-width": "68px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "角色名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入角色名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleQuery.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.queryParams.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "name", $$v)
                  },
                  expression: "queryParams.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-search",
                    size: "mini",
                  },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v(" 搜索 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticClass: "mb8",
          attrs: { gutter: 10, type: "flex", justify: "end" },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["roles_add"],
                      expression: "['roles_add']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    size: "small",
                  },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(" 新增角色 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { "margin-top": "10px" },
          attrs: { data: _vm.roleList },
        },
        [
          _c("el-table-column", {
            directives: [
              {
                name: "permission",
                rawName: "v-permission",
                value: ["roles_edit", "roles_enable", "roles_disable"],
                expression: "['roles_edit', 'roles_enable', 'roles_disable']",
              },
            ],
            attrs: {
              label: "操作",
              align: "center",
              "class-name": "small-padding fixed-width",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["roles_edit"],
                            expression: "['roles_edit']",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          type: "text",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(scope.row)
                          },
                        },
                      },
                      [_vm._v(" 修改 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["roles_enable", "roles_disable"],
                            expression: "['roles_enable', 'roles_disable']",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          type: "text",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleChangeStatus(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(scope.row.enable ? "禁用" : "启用") + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "状态", align: "center", prop: "id" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: row.enable ? "" : "danger" } },
                      [_vm._v(" " + _vm._s(row.enable ? "启用" : "禁用") + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "角色名称", align: "center", prop: "roleName" },
          }),
          _c("el-table-column", {
            attrs: { label: "角色权限", align: "center", prop: "gender" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          row.menuAuth
                            .map(function (item) {
                              return item.name
                            })
                            .join(",")
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "角色描述",
              align: "center",
              prop: "roleDesc",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "创建人/修改人", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(row.creatorName) + "/" + _vm._s(row.updaterName)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间/修改时间",
              align: "center",
              prop: "createTime",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(row.createTime) + "/" + _vm._s(row.updateTime)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.current,
          limit: _vm.queryParams.size,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "current", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "size", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.open,
            width: "390px",
            "append-to-body": "",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "roleForm",
              attrs: {
                model: _vm.roleForm,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "角色名称", prop: "roleName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入角色名称" },
                    model: {
                      value: _vm.roleForm.roleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.roleForm, "roleName", $$v)
                      },
                      expression: "roleForm.roleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "menuCodes", label: "角色权限" },
                  model: {
                    value: _vm.roleForm.menuCodes,
                    callback: function ($$v) {
                      _vm.$set(_vm.roleForm, "menuCodes", $$v)
                    },
                    expression: "roleForm.menuCodes",
                  },
                },
                [
                  _c("treeselect", {
                    attrs: {
                      multiple: true,
                      limit: 2,
                      options: _vm.menuOptions,
                      limitText: _vm.limitText,
                      placeholder: "选择权限",
                      noChildrenText: "无数据",
                      normalizer: _vm.normalizer,
                    },
                    on: { close: _vm.handleCloseTree },
                    model: {
                      value: _vm.roleId,
                      callback: function ($$v) {
                        _vm.roleId = $$v
                      },
                      expression: "roleId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "角色描述" } },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "" },
                    model: {
                      value: _vm.roleForm.roleDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.roleForm, "roleDesc", $$v)
                      },
                      expression: "roleForm.roleDesc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.buttonLoading, type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(" 确 定 ")]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }